<!--
 * @Description:查询
 * @Version: 2.0
 * @Autor: daikeyi
 * @Date: 2020-06-05 15:25:04
 * @LastEditors: daikeyi
 * @LastEditTime: 2021-01-20 11:22:52
-->

<template>
    <div>
        <div v-if="type === '3'" class="icon-search" @click="goSearch">
            <svg-icon icon-class="search" className="search-svg"></svg-icon>
        </div>
        <div class="commonSearch" :class="{spanColor: type === '2' ?  true : false}" @click="goSearch" v-else>

            <span>{{searchMassage}}</span>
        </div>

    </div>
</template>
<script>
export default {
    name: 'home',
    props: ['searchType', 'searchMassage', 'type'],
    data() {
        return {
            spanFlag: false
        };
    },
    methods: {
        goSearch() {
            console.log(this.searchMassage);
            this.$emit('goSearch', this.searchMassage);
        }
    }
};

</script>
<style lang="scss" scoped>
.icon-search {
    width: 16px;
    height: 16px;
    .search-svg {
        width: 16px;
        height: 16px;
    }
    // width: 15px;
    // height: 15px;
    // img {
    //     width: 100%;
    // }
}
.commonSearch {
    position: absolute;
    top: 10px;
    left: 50%;
    margin-left: -46.8%;
    display: flex;
    // justify-content: center;
    align-items: center;
    position: absolute;
    background: #F6F6F6;
    width: 93.6%;
    height: 25px;
    border-radius: 25px;
    z-index: 100000;
    img {
        width: 15px;
        height: 15px;
        margin: 0 8px;
    }
    span {
        color: #BEBEC5;
        font-size: 14px;
    }
}
.homeSearch {
    justify-content: center;
    border-radius: 0;
    background: rgba(255,255,255,0.80);
}
.spanColor {
    justify-content: flex-start;
    span {
        display: block;
        width: 100%;
        color: #414141;
        margin: 0 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}
</style>
